import Component from '@glimmer/component'
import Icon from 'customer-flows/components/ui-kit/icon'

interface StaticFooterArgs {
  text?: string
}

export default class StaticFooterComponent extends Component<StaticFooterArgs> {
  <template>
    <il-static-footer
      data-testid='booking-flow__static-footer'
      class='w-full [--il-static-footer-background-color:var(--il-color-neutrals-0)]'
    >
      <div slot='left-side' data-testid='booking-flow__static-footer__left'>
        <Icon @src='peek-logo' />
      </div>

      <div slot='right-side' data-testid='booking-flow__static-footer__right' class='ml-2'>
        <div data-testid='booking-flow-static-footer-text'>
          {{@text}}
        </div>
      </div>

    </il-static-footer>
  </template>
}
